/**
 * Trạng thái của form
 */
export default {
  None: 0,
  One: 1,
}
